import { AlternativeWidgetsNameInterface } from '../interfaces/nt-AlternativeWidgetsName';

export const ALTERNATIVE_WIDGETS_NAME_NT: AlternativeWidgetsNameInterface[] = [
    {
      id: 1,
     // className: 'widget-heatmap',
      text: "Heatmap Accesso",
    },
    {
      id: 4,
     // className: 'widget-curva-mercato',
      text: 'Curva di Accesso',
    },
    {
      id: 10,
   //   className: 'widget-evolution-regional-market',
      text: 'Evoluzione Accesso',
    },
    {
      id: 19,
   //   className: 'widget-forecast-accuracy-openToMarket',
      text: "Forecast Accuracy di Accesso",
    },
        {
      id: 21,
     // className: 'widget-open-to-market-curve-30-days',
      text: "Curva di Accesso*",
    },
            {
      id: 22,
    // className: 'widget-evolution-regional-market-30-days',
      text: 'Evoluzione Accesso*',
    },

  ];

